export const SAVE = 'StudentMedicalBenefitsTugo.SAVE';
export const VALUE_CHANGED = 'StudentMedicalBenefitsTugo.VALUE_CHANGED';
export const LOAD = 'StudentMedicalBenefitsTugo.VALUE_LOAD';
export const NEXT = 'StudentMedicalBenefitsTugo.NEXT';
export const RESET = 'StudentMedicalBenefitsTugo.RESET';

export const RESET_FORM_STATE = 'StudentMedicalBenefitsTugo.RESET_FORM_STATE';

export const REPORT_TO = {
  POLICE: '1',
  HOTEL_MANAGEMENT: '2',
  CRUISE_SHIP: '3',
  AIRLINE: '4',
  TOUR_GUIDE: '5',
  OTHER: '6',
  NOT_REPORT: '20',
};

export const CLAIMING_FOR = {
  PASSPORT_CREDIT_CARD: 'claimForPassportCreditCard',
  THEFT_OF_CASH: 'claimForTheftOfCash',
  LUGGAGE_AND_PERSONAL_EFFECTS: 'claimForLuggageAndPersonalEffect',
};

export const MEDICAL_EXPENSE_TYPES = {
  DOCTORS_VISIT: "Doctor's Visit",
  DIAGNOSTIC_TESTS: 'Diagnostic Tests',
  PRESCRIPTION_DRUGS: 'Prescription Drugs',
  AMBULANCE_SERVICES: 'Ambulance Services',
  HOSPITALIZATION: 'Hospitalization',
  ESSENTIAL_MEDICAL_APPLIANCES: 'Essential Medical Appliances',
  PRIVATE_DUTY_NURSING: 'Private Duty Nursing',
  FRACTURE_TREATMENT: 'Fracture Treatment',
  MATERNITY_BENEFITS: 'Maternity Benefits',
  PROFESSIONAL_SERVICES: 'Professional Services',
  REHABILITATION_TREATMENT: 'Rehabilitation Treatment',
  DENTAL_SERVICES: 'Dental Services',
  PRESCRIPTION_GLASSES_CONTACT_LENSES_HEARING_AIDS: 'Prescription Glasses, Contact Lenses or Hearing Aids',
  TUTORIAL_SERVICES: 'Tutorial Services',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StudentMedicalBenefits/constants.js